import Form from 'react-bootstrap/Form';
import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';

const DefaultDatepicker = ({
  value,
  label,
  showLabel = true,
  dateFormat = 'DD-MM-YYYY',
  timeFormat = false,
  required = false,
  onChange,
  onBlur,
  hasError = false,
  errorMessage = '',
}) => {
  return (
    <Form.Group className="mb-4">
      {showLabel && <Form.Label className={`${required ? 'form--required' : ''}`}>{label}</Form.Label>}
      <Datetime
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className="datepicker"
      />
      {hasError && errorMessage !== '' && <small className={'text-danger d-block mt-2'}>{errorMessage}</small>}
    </Form.Group>
  );
};

export default DefaultDatepicker;
